export const RPC_URL = "http://localhost:8545/";
export const RPC_WS_URL = "ws://localhost:8545/";
export const DEV_PRIVATE_KEY = "0x044C7963E9A89D4F8B64AB23E02E97B2E00DD57FCB60F316AC69B77135003AEF";
export const DIAMOND_ADDRESS = "0x942cBa5081416e2A3389c5338722ccc6912B9115";
export const CHECKPOINT_URL = "http://localhost:50052";
export const LAYER_NAME = "network";
